/**
 * Ecranul de încărcare din public/index.html (#splash), ca la Validez: acoperă rezumatul SEO nestilizat din
 * #root (trimis de shell-ul SEO din artaNftBE, ADR-0001) și primele randări, până când pagina deschisă are
 * datele - linkul deschis din Facebook nu mai „pâlpâie”. Rezumatul rămâne în DOM pentru crawlere.
 * - paginile publice cu date (acasă, liste, expoziție, membru, lucrare): îl ascund ele, după încărcare;
 * - restul (panou, login, contact...): App, imediat.
 * Limită de siguranță în index.js: nu rămâne afișat dacă API-ul nu răspunde. Idempotent.
 */
export const SPLASH_TIMEOUT_MS = 5000;

export function hideSplash() {
    const el = document.getElementById('splash');
    if (!el || el.classList.contains('splash-hide')) return;
    el.classList.add('splash-hide');
    window.setTimeout(() => el.remove(), 250);
}

/** Paginile care ascund singure ecranul, după date (vezi mai sus). */
export const waitsForData = (pathname) => pathname === '/' || /^\/(expozitii|artisti|colectionari)(\/|$)/.test(pathname);
